<template>
	<div class="back">
		<div class="xcontont">
			<!-- 上部分:图标 -->
			<div class="xcontont-top">
				<span>订单提交成功，请尽快付款！订单编号：{{orderId}}</span>
				<span>应付金额<b>{{yfPrice?(yfPrice-0).toFixed(2):''}}</b>元</span>
			</div>
			<!-- 下部分:支付成功和按钮 -->
			<div class="xcontont-btm">
				<ul class="xcontont-btm-ul0">
					<li class="li0">{{payorder}}支付</li>
					<li class="li1">距离二维码过期还剩<b>{{downTimeNum>=0?downTimeNum:'1'}}</b>秒，过期后请刷新页面重新获取二维码！</li>
				</ul>
				<ul class="xcontont-btm-ul1">
					<li>
						<dd><img :src="srcImg"></dd>
						<dt style="margin-top: 20rpx;">
							<img src="../../assets/img/privacy/orderpay_ewm.png">
							<div>
								<span>请使用{{payorder}}扫一扫</span>
								<span>扫描二维码支付</span>
							</div>
						</dt>
					</li>
				</ul>
			</div>
		</div>
	</div>

</template>

<script>
	let _self;
	let timeDjs;
	let orderTime;
	import {
		appUserPayOrder,//支付总订单
		appUserPayBackstage,//支付子订单
		appUserFindByOrerInfo,//总订单详情
		wxPayState,	//微信==判断订单是否支付
	} from '@/api/orderXq.js'
	import Vue from 'vue'
	import buyjd from '../../components/buyJd.vue'
	export default {
		name: 'OrderPay',
		data() {
			return {
				// 服务器地址
				baseUrlTxt:this.$store.getters.getBaseUrl,
				// 用户信息
				userInfo:null,
				// 订单id
				orderId:null,
				// 应付金额
				yfPrice:null,
				// 倒计时
				downTimeNum:60,
				
				
				
				srcImg:null,
				// 微信接口参数
				wxJkData:null,
				// 微信支付宝
				payorder:'微信',
				// 微信商户订单号
				wXOrderCode:null,
			}
		},
		beforeCreate() {
			_self=this;
		},
		// 常用生命周期
		created() {
			// console.log('服务器地址====',this.baseUrlTxt);
			// 用户信息处理===用户信息传递
			_self.userInfo=this.getUInfo();
			// console.log('用户信息===',_self.userInfo);
			this.$EventBus.$emit('AppCloseNav', true);
			
			// 判断页面传参信息
			try{
				// 解码获取的路由参数
				let pageVal=decodeURIComponent(_self.$router.history.current.query.info);
				// json化数据
				let jxVal=JSON.parse(pageVal || '{}');
				// 判断页面是否有传值信息
				if(pageVal && jxVal && jxVal.orderId){
					console.log('二维码支付页面传递参数===',jxVal);
					
					
					if(jxVal.orderType==true){
						// 总订单
						
						// 微信支付===定义信息
						// 定义微信订单号，用于查询用户是否支付
						_self.wXOrderCode=jxVal.orderCode;
						// 定义订单id
						_self.orderId=jxVal.orderId;
						// 定义微信接口请求蚕食
						_self.wxJkData=jxVal.rstData;
						// 获取订单信息
						_self.handleGetOrderInfo();
					}else{
						// 子订单
						// console.log('开始获取子订单===');
						
						// 定义接口请求参数
						_self.wxJkData=jxVal.rstData;
						// 定义订单id
						_self.orderId=jxVal.orderId;
						// 微信支付===定义信息
						// 定义微信订单号，用于查询用户是否支付
						_self.wXOrderCode=jxVal.orderCode;
						// 定义商品总价
						_self.yfPrice=jxVal.yfPrice;
						// 开始请求微信二维码
						_self.handleGetWxSonCodeImg();
						// 开始倒计时
						_self.handleOpenTimeStart();
					}
				}else{
					_self.$eror('商品信息错误！')
					// 无页面传值===返回首页
					_self.$router.replace({name:'ShopCar'});
				}
			}catch(err){
				_self.$eror('商品信息错误。')
				// 出现错误的情况下===》跳转回首页
				_self.$router.replace({name:'ShopCar'});
			}
		},
		methods: {
			// 获取订单信息
			handleGetOrderInfo(){
				appUserFindByOrerInfo({
					orderId:_self.orderId
				}).then(res=>{
					console.log('二维码页面==订单信息====》',res);
					
					if(res.code==200){
						// 定义商品应付金额
						// _self.yfPrice=res.data.orderInfo.orderSum;
						_self.yfPrice=res.data.orderInfo.orderCouponSum;
						// 开始请求微信二维码
						_self.handleGetWxCodeImg();
						// 开始倒计时
						_self.handleOpenTimeStart();
					}
				})
			},
			// 获取微信二维码
			handleGetWxCodeImg(){
				_self.$store.commit('setWxCode',true);
				// 微信支付接口
				
				
				let data = new FormData()
				for(let i in _self.wxJkData){
					data.append(i,_self.wxJkData[i])
				}
				
				this.$axios({
				    method: 'POST',
				    url: this.baseUrlTxt+'admin/appCUserorder/appUserPayOrder',
				    data: data,
				    params: data,
				    responseType: 'arraybuffer'
				}).then(res=>{
					console.log('总订单微信二维码===112233',res);
					
					// 判断订单是否支付成功
					if(res.data){
							// 判断是否0元支付
							if(res && res.data=='0元支付' &&res.code==200){
								// 直接跳转支付成功页面
								_self.$router.replace({name:'OrderPaySuc'})
							}else{
								_self.srcImg = 'data:image/jpeg;base64,'+ _self.$commonFun.arrayBufferToBase64(res.data);
								// 定时查询订单是否成功 
								_self.handleGetOrderPay();
								// console.log('图片===',_self.srcImg);
							}
						// let content = res.data;//arraybuffer类型数据
						// let resBlob = new Blob([content])
						// let reader = new FileReader()
						// reader.readAsText(resBlob, "utf-8")
						// reader.onload = () => {
						// 	console.log('=====res',reader.result);
							
						// 	// let res =reader && reader.result?JSON.parse(reader.result):null;
							
						// 	// 判断是否0元支付
						// 	if(res && res.data=='0元支付' &&res.code==200){
						// 		// 直接跳转支付成功页面
						// 		_self.$router.replace({name:'OrderPaySuc'})
						// 	}else{
						// 		_self.srcImg = 'data:image/jpeg;base64,'+ _self.$commonFun.arrayBufferToBase64(res.data);
						// 		// 定时查询订单是否成功
						// 		_self.handleGetOrderPay();
						// 		// console.log('图片===',_self.srcImg);
						// 	}
						// }
					}
				})
			},
			// 子订单获取微信二维码
			handleGetWxSonCodeImg(){
				let data = new FormData()
				for(let i in _self.wxJkData){
					data.append(i,_self.wxJkData[i])
				}
				
				this.$axios({
				    method: 'POST',
				    url: this.baseUrlTxt+'admin/appCUserorder/appUserPayBackstage',
				    data: data,
				    params: data,
				    responseType: 'arraybuffer'
				}).then(res=>{
					// console.log('子订单===微信二维码===112233',res);
					
					// 判断订单是否支付成功
					if(res.data){
						
						// 判断是否0元支付
						if(res && res.data=='0元支付' &&res.code==200){
							// 直接跳转支付成功页面
							_self.$router.replace({name:'OrderPaySuc'})
						}else{
							_self.srcImg = 'data:image/jpeg;base64,'+ _self.$commonFun.arrayBufferToBase64(res.data);
							// 定时查询订单是否成功 
							_self.handleGetOrderPay();
							// console.log('图片===',_self.srcImg);
						}
						
						
						// let content = res.data;//arraybuffer类型数据
						// let resBlob = new Blob([content])
						// let reader = new FileReader()
						// reader.readAsText(resBlob, "utf-8")
						// reader.onload = () => {
						// 	// let res = JSON.parse(reader.result)
						// 	let res = eval(reader.result)
						// 	console.log('=====res',res);
							
						// 	// 判断是否0元支付
						// 	if(res && res.data=='0元支付' &&res.code==200){
						// 		// 直接跳转支付成功页面
						// 		_self.$router.replace({name:'OrderPaySuc'})
						// 	}else{
						// 		_self.srcImg = 'data:image/jpeg;base64,'+ _self.$commonFun.arrayBufferToBase64(res.data);
						// 		// 定时查询订单是否成功
						// 		_self.handleGetOrderPay();
						// 		// console.log('图片===',_self.srcImg);
						// 	}
						// }
					}
				})
			},
			
			// 判断订单是否支付
			handleGetOrderPay(){
				// console.log('开始查询订单是否完成支付=====');
				wxPayState({
					number:_self.wXOrderCode
				}).then(res=>{
					// console.log('订单支付状态===',res);
					if(res.data=='查询异常！'){
						// 清楚定时器
						clearInterval(orderTime);
						// 跳转到支付成功页面
						_self.$router.replace({name:'Home'})
					}else if(res.data && res.data.tradeStateDesc=='支付成功'){
						// 清楚定时器
						clearInterval(orderTime);
						// 跳转到支付成功页面
						_self.$router.replace({name:'OrderPaySuc'})
					}else if(res.data=='订单不存在'){
						orderTime&&clearInterval(orderTime);
					}else{
						orderTime&&clearInterval(orderTime);
						orderTime=setTimeout(()=>{
							// 定时查询订单
							_self.handleGetOrderPay();
						},3000)
					}
				})
			},
			// 开始倒计时
			handleOpenTimeStart(){
				timeDjs && clearInterval(timeDjs);
				timeDjs=setInterval(()=>{
					if(_self.downTimeNum==1){
						// 刷新页面
						location.reload();
					}else{
						_self.downTimeNum--;
					}
				},1000)
			},
		},
		// 组件
		components: {
			buyjd
		},
		// 计算
		computed: {

		},
		destroyed() {
			clearInterval(timeDjs);
			clearInterval(orderTime);
		},
		beforeRouteEnter(to, from, next) {
			// next();
			// 判断是否登录===登录，允许进入||未登录，返回登陆页
			let info = localStorage.getItem('userInfo');
			info ? next() : next('/Login')
		},
		
		beforeMount() {},
		mounted() {
			// 滚动到头部
			window.scrollTo({
				left: 0,
				top: 0,
			});
		},
		beforeDestroy() {}
	}
</script>

<style lang="scss" scoped="scoped">
	// 盒子居中
	@mixin center {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	// 字体方法
	@mixin font($fs, $fw, $cl) {
		opacity: 1;
		font-size: $fs;
		font-family: Source Han Sans CN, Source Han Sans CN-Bold;
		font-weight: $fw;
		color: $cl;
	}

	.back {
		background-color: #f5f5f5;
		padding-bottom: 53px;
		.xcontont {
			width: 1200px;
			margin: 0 auto;
			font-size: 24px;
			font-weight: 400;
			text-align: left;
			&-top {
				width: 100%;
				height: 106px;
				background: #f5f5f5;
				display: flex;
				justify-content: space-between;
				align-items: center;
				@include font(20px, 400, #666666);

				span {
					font-size: 20px;
					font-family: Microsoft YaHei, Microsoft YaHei-Regular;
					font-weight: 400;
					text-align: left;
					color: #666666;
					b {
						font-size: 24px;
						color: #E62129;
					}
				}
			}

			&-btm {
				width: 1200px;
				height: 700px;
				display: flex;
				flex-flow: column;

				&-ul0 {
					width: 100%;
					height: 90px;
					background: #ffffff;
					display: flex;
					align-items: center;

					.li0 {
						margin-left: 30px;
						@include font(24px, 400, #000000);
					}

					.li1 {
						margin-left: 80px;
						@include font(16px, 400, #000000);
					}

					b {
						color: #E62129;
					}
				}

				&-ul1 {
					flex: 1;
					background-color: #ffffff;
					li {
						width: 400px;
						margin: 26px 0px 0px 215px;
						display: flex;
						flex-flow: column;
						justify-content: space-between;

						dd {
							display: inline-block;
							width: 100%;
							height: 400px;
							border: 2px solid #cccccc;
							box-sizing: border-box;
							padding: 20px;
							box-sizing: border-box;

							img {
								width: 360px;
								height: 360px;
							}

						}

						dt {
							display: inline-block;
							width: 100%;
							height: 72px;
							background: #ffb6b9;
							display: flex;
							align-items: center;
							justify-content: center;

							div {
								height: 50px;
								display: flex;
								flex-flow: column;
								justify-content: space-between;
								@include font(16px, 400, #ffffff);
								margin-left: 10px;
								letter-spacing: 2px;
							}
						}
					}
				}

			}
		}

		.xcontont::-webkit-scrollbar {
			display: none;
		}
	}
</style>
